import Grid from '@mui/material/GridLegacy';
import React from 'react';

import { spaces } from '../../../../assets/styles/themes/tokens';
import type { IconName } from '../../../../utils/getMuiIcon';
import type { TemplatePromptCardId } from '../constants';
import AIFeatureCard from './AIFeatureCard';

// Generic in the id so a list of template-prompt-only cards keeps its narrow ids:
// the KI Tools landing widens `Id` to include the corrections sentinel, the Muki
// dialog stays on `TemplatePrompts` and its click handler needs no assertion.
export interface TemplatePromptItem<Id extends TemplatePromptCardId = TemplatePromptCardId> {
	id: Id;
	title: string;
	subheader: string;
	icon: IconName;
	chip?: 'new' | 'beta';
}

interface AIAssistantTemplatePromptListProps<Id extends TemplatePromptCardId> {
	items: TemplatePromptItem<Id>[];
	isExtended: boolean;
	onPromptClick?: (title: string, subheader: string, id: Id) => void;
	gridItemProps?: {
		xs?: number;
		sm?: number;
		md?: number;
	};
}

const AIAssistantTemplatePromptList = <Id extends TemplatePromptCardId>({
	items,
	isExtended,
	onPromptClick,
	gridItemProps,
}: AIAssistantTemplatePromptListProps<Id>) => {
	const defaultGridProps = {
		xs: 12,
		sm: 6,
		md: isExtended ? 3 : 6,
	};

	const finalGridProps = gridItemProps || defaultGridProps;

	return (
		<Grid container spacing={1} sx={{ paddingTop: spaces.md }}>
			{items.map(({ id, title, subheader, icon, chip }) => (
				<Grid item key={id} xs={finalGridProps.xs} sm={finalGridProps.sm} md={finalGridProps.md}>
					<AIFeatureCard
						title={title}
						icon={icon}
						description={subheader}
						chip={chip}
						testId={`ai-assistant-template-prompt-card-${id}`}
						onClick={() => onPromptClick?.(title, subheader, id)}
					/>
				</Grid>
			))}
		</Grid>
	);
};

export default AIAssistantTemplatePromptList;
